var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-alert-dialog',{class:[
    {
      '--centered': _vm.centered,
      '--no-title': !_vm.title,
      '--vertical-actions': _vm.verticalActions
    }
  ],attrs:{"title":_vm.title,"visible":_vm.innerShow,"footer":_vm.footerLinks,"cancelable":true},on:{"update:visible":[function($event){_vm.innerShow=$event},_vm.updateVisible]}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }